import React from 'react'

function Newton() {
  return (
    <div>Newton</div>
  )
}

export default Newton